import React from "react";
import "react-toggle/style.css"
import { IPaymentChoice } from "../classes/Domain";
import Utilities from "../classes/Utilities";
import { ToggleButton } from '@material-ui/lab';

interface IState {
	selected: boolean,
	paymentChoice: IPaymentChoice;
}

interface IProps {
	paymentChoice: IPaymentChoice,	
	onSelected(paymentChoice: IPaymentChoice): void,
}

class PaymentChoice extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);

		this.state = {
			selected: this.props.paymentChoice.selected,
			paymentChoice: this.props.paymentChoice
		};

		this.onPaymentChoiceSelected = this.onPaymentChoiceSelected.bind(this);
	}

	onPaymentChoiceSelected() {
		this.setState({ ...this.state, selected: !this.state.paymentChoice.selected }, () => {
			this.state.paymentChoice.selected = this.state.selected;
			this.props.onSelected(this.state.paymentChoice);
		});
    }

	render() {
		return (
			<div className="payment-choice">
				<div className="term">
					<div className="term-name">
						{this.props.paymentChoice.payTerm}
					</div>
					<div className="select-term text-right">
						<ToggleButton
							id={Utilities.uniqueId()}
							value={Utilities.uniqueId()}
							selected={this.state.selected}
							onChange={this.onPaymentChoiceSelected}
							style={{ background: `${this.state.selected ? "#34B629" : "#999b9e"}` }}
							className="slectResult"
						>
							Select
						</ToggleButton>
					</div>
				</div>
				<div className="item">
					<label><strong>{this.props.paymentChoice.payPlanDesc}</strong></label>
				</div>
				{
					this.props.paymentChoice.payTermCd === 'FULL'
						?
						<div className="item">
							<label className="left-cell">One-time payment</label>
							<label className="right-cell"><strong>{Utilities.formatCurrency(this.props.paymentChoice.firstPay)}</strong></label>
						</div>
						:
						<div>
							<div className="item">
								<label className="left-cell">Down Payment</label>
								<label className="right-cell"><strong>{Utilities.formatCurrency(this.props.paymentChoice.firstPay)}</strong></label>
							</div>
							<div className="item">
								<label className="left-cell">Per Payment</label>
								<label className="right-cell"><strong>{Utilities.formatCurrency(this.props.paymentChoice.regularPay)}</strong></label>
							</div>
						</div>
				}
			</div>
		);
	}
}

export default PaymentChoice;